














































import { Vue } from 'vue-property-decorator'
import ResourceTile from '../../components/ResourceTile.vue'
import ResourceDirectoryTile from '../../components/ResourceDirectoryTile.vue'

interface IAgentResourceFavorite {
  id: number
  name: string
  description: string
  numberOfChildren: number
  isDirectory: boolean
  favoriteId: number
  createdDate: string
  resourceLink: string
  imageUrl: string
}

export default Vue.extend({
  data: function () {
    return {
      loading: true,
      agentresourceFavorites: [] as IAgentResourceFavorite[],
      routes: [{ id: '', name: 'Reinsurance Resources' }] as {
        id: string | undefined
        name: string
      }[],
      currentPath: '/',
      favoriteIcon: "../../icons/favorite.png"
    }
  },
  mounted: async function () {
    this.agentresourceFavorites = await (
      await fetch('/api/ReinsuranceResources/favorites')
    ).json()
    this.agentresourceFavorites = this.agentresourceFavorites.map((x) => ({
      ...x,
      name: x.path.split('/')[x.path.split('/').length - 1],
      type: 'agent-resources',
    }))
    this.loading = false
  },
  methods: {
    removeFavoriteDocument(favoriteId: number) {
      // Trigger the common api removal in the parent element
      this.$emit('remove-favorite', favoriteId)

      this.agentresourceFavorites = this.agentresourceFavorites.filter(
        (agentrf) => agentrf.favoriteId !== favoriteId
      )
    },
    descendIntoDirectory: async function (name: string, path: string) {
      this.loading = true
      const newPath = (this.currentPath + '/').replace('//', '/') + path
      this.routes.push({
        id: newPath,
        name: name ?? '',
      })
      this.$router.push({
        name: 'Reinsurance Resources',
        params: { path: newPath },
      })
      this.currentPath = newPath
      this.reinsuranceResources = await (
        await fetch(`/api/reinsuranceresources?path=${newPath}`)
      ).json()
      
      this.loading = false
    },
  },
  components: {
    ResourceTile,
    ResourceDirectoryTile,
  },
})
